export interface LoadDebouncedInput {
  id: string;
  showLoader: boolean;
  cb?: () => void;
}

export type LoadInput = LoadDebouncedInput | boolean;

export const isDebouncedInput = (input: LoadInput): input is LoadDebouncedInput => typeof input !== 'boolean';

// The loader flag uses the value of the last request buffered in the debounce window.
export const resolveShowLoader = (inputs: Array<LoadInput>): boolean => {
  const last = inputs.at(-1);
  return isDebouncedInput(last) ? last.showLoader : last;
};

export const runCallbacks = (inputs: Array<LoadInput>): void => {
  inputs.forEach((input) => {
    if (isDebouncedInput(input)) {
      input.cb?.();
    }
  });
};
